/* Affiliate Portal (sections/affiliate-portal.liquid): scroll reveals, earnings calculator, mobile apply dock. */
(() => {
  const init = (root) => {
    if (root.dataset.kapReady) return;
    root.dataset.kapReady = 'true';

    // Scroll reveals. The hidden state is only applied once JS is running, so content never stays invisible.
    const reveals = root.querySelectorAll('.kap-reveal');
    if ('IntersectionObserver' in window) {
      root.classList.add('is-ready');
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      reveals.forEach((el) => io.observe(el));
    }

    // Earnings calculator
    const range = root.querySelector('[data-kap-range]');
    if (range) {
      const perSale = Number(root.dataset.perSale) / 100;
      const count = root.querySelector('[data-kap-count]');
      const month = root.querySelector('[data-kap-month]');
      const year = root.querySelector('[data-kap-year]');
      let money;
      try {
        money = new Intl.NumberFormat(root.dataset.locale || undefined, {
          style: 'currency',
          currency: root.dataset.currency || 'USD',
          maximumFractionDigits: 0,
        });
      } catch (e) {
        money = { format: (n) => '$' + Math.round(n).toLocaleString() };
      }

      const update = () => {
        const n = Number(range.value);
        const min = Number(range.min);
        const max = Number(range.max);
        range.style.setProperty('--kap-fill', ((n - min) / (max - min)) * 100 + '%');
        count.textContent = n;
        month.textContent = money.format(perSale * n);
        year.textContent = money.format(perSale * n * 12);
      };
      range.addEventListener('input', update);
      update();
    }

    // Mobile dock: visible once the hero is out of view, hidden again over the closing CTA.
    const dock = root.querySelector('[data-kap-dock]');
    const hero = root.querySelector('[data-kap-hero]');
    const cta = root.querySelector('[data-kap-cta]');
    if (dock && hero && 'IntersectionObserver' in window) {
      const state = { pastHero: false, atCta: false };
      const link = dock.querySelector('a');
      const sync = () => {
        const show = state.pastHero && !state.atCta;
        dock.classList.toggle('is-visible', show);
        dock.setAttribute('aria-hidden', String(!show));
        if (link) link.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(([entry]) => {
        state.pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sync();
      }).observe(hero);
      if (cta) {
        new IntersectionObserver(([entry]) => {
          state.atCta = entry.isIntersecting;
          sync();
        }).observe(cta);
      }
    }
  };

  const boot = () => document.querySelectorAll('[data-kap]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
